export default __webpack_public_path__ + "static/media/71.5c19d944.jpg";